<template>
	<div class="banner-container">
		<div class="container">
			<h3 class="banner-badge">시작하기</h3>
			<h2 class="banner-title">더 쉬운 중국 직구의 시작</h2>
			<p class="banner-desc">고로켓고이 이용 방법을 안내합니다</p>
		</div>
	</div>
</template>

<script>
	export default {
		computed: {
			isMobile() {
			  return window.innerWidth <= 768;
			},
		},
	}
</script>

<style scoped>
	.banner-container {
		width: 100%;
		height: 320px;
		background: #ffffff;
		display: flex;
		align-items: center;
		justify-content: center;
		border-bottom: 1px solid #eee;
	}
	
	.container {
		text-align: center;
	}

	.banner-badge {
		color: rgb(247, 148, 29);
		font-size: 24px;
		font-weight: 700;
		margin-bottom: 15px;
	}

	.banner-title {
	    font-weight: 700;
	    font-size: 44px;
	    color: #1E3A5F;
		letter-spacing: -0.5px;
		margin-bottom: 15px;
	}

	.banner-desc {
		color: #888;
		font-size: 18px;
		font-weight: 500;
	}

	@media (max-width: 768px) {
		.banner-container {
			height: 240px;
		}
		.banner-badge {
			font-size: 18px;
		}
		.banner-title {
		    font-size: 28px;
		}
		.banner-desc {
			font-size: 14px;
		}
	}
</style>